module.exports = __webpack_public_path__ + "img/TransactionData.823e9e8a.svg";